<template>
  <div class="c-setting">
    <div class="body ly-card" v-show="tab === 1">
      <el-button class="m-b-10" @click="add" type="primary">新增</el-button>
      <table class="native-table" v-loading="loading">
        <tr>
          <th>序号</th>
          <th>轮播图</th>
          <th>链接地址</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item, index) in data" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>
            <el-image
              style="width: 80px;"
              :preview-src-list="imageList"
              :src="`${baseUrl}/${item.image_url}`"
            ></el-image>
          </td>
          <td>
            <a
              class="el-button el-button--text el-button--mini"
              v-if="item.link_type === 2"
              :href="item.link_address"
              target="_blank"
              >{{ item.link_address }}</a
            >
            <el-button v-else @click="gotoNewsContent(item)" type="text" size="mini">{{
              item.content_title
            }}</el-button>
          </td>
          <td>
            <el-button @click="edit(item)" type="text" size="mini">修改</el-button>
            <el-button @click="del([item.id])" type="text" size="mini" class="el-button--danger">删除</el-button>
          </td>
        </tr>
      </table>
    </div>
    <el-dialog title="添加轮播图" :visible.sync="dialogVisible" width="600px">
      <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm">
        <template v-slot:image_url="{ formData }">
          <img v-show="formData.image_url" :src="`${baseUrl}/${formData.image_url}`" width="50" alt="轮播图" />
          <upload
            :action="cUpload"
            @successCBK="value => mediaChange('image_url', value, formData)"
            accept=".jpg, .jpeg, .png, .gif, .bmp"
          />
        </template>
        <template v-slot:link_type="{ formData }">
          <el-radio v-model="formData.link_type" :label="1" border>内链</el-radio>
          <el-radio v-model="formData.link_type" :label="2" border>外链</el-radio>
          <div class="m-t-10 input-group">
            <remote-search
              v-if="formData.link_type === 1"
              :defaultData="defaultData"
              :options="insider_posts_id"
              :paramsData="{ page_no: 1, page_size: 20 }"
              ref="insider_posts_id"
              @input="postshandleChange"
            />
            <el-input placeholder="外链地址" v-model="link_address" v-if="formData.link_type === 2"></el-input>
          </div>
        </template>
      </ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Input, Radio, Image } from 'element-ui';
import LyForm from '@/components/LyForm';
import cSetting from '@/api/cSetting';
import { postsOffTable } from '@/utils/communityHeader';
import localCache from '@/utils/localCache';
import Upload from '@/components/cUpload';
import RemoteSearch from '@/components/common/RemoteSearch';
import { insider_posts_id } from '@/utils/formConfigCommon';

const BANNER_TYPE_OBJ = { insider_content_type: 2 }; // 轮播图类型

export default {
  name: 'NewsSetting',
  components: {
    LyForm,
    Upload,
    ElDialog: Dialog,
    ElInput: Input,
    ElRadio: Radio,
    RemoteSearch,
    ElImage: Image
  },
  data() {
    return {
      cUpload: cSetting.cUpload,
      tableHeader: postsOffTable,
      getTableData: cSetting.getBanner,
      tab: 1,
      data: [],
      baseUrl: '',
      dialogVisible: false,
      defaultFormItem: {
        link_type: 1
      },
      formConfig: {
        inline: false,
        'label-width': '100px',
        'label-position': 'left'
      },
      formKeys: {
        image_url: {
          type: 'slot',
          label: '轮播图',
          placeholder: '请上传轮播图',
          rules: [
            {
              required: true,
              trigger: 'change',
              message: '请上传轮播图'
            }
          ]
        },
        link_type: {
          type: 'slot',
          label: '链接地址',
          placeholder: '请填写链接地址',
          rules: [
            {
              required: true,
              trigger: 'change',
              message: '请填写链接地址'
            }
          ]
        }
      },
      link_address: '',
      post: {
        insider_posts_id: '',
        title: ''
      },
      insider_posts_id: {
        ...insider_posts_id.options,
        metholdKey: 'newsContent',
        label: 'content_title',
        placeholder: '请输入标题关键词搜索',
        key: 'insider_posts_id'
      },
      defaultData: {},
      imageList: [],
      loading: false
    };
  },
  mounted() {
    this.init();
  },
  filters: {
    longText(value) {
      return value && value.length > 60 ? `${value.slice(0, 60)}...` : value;
    }
  },
  methods: {
    async init() {
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
      this.loading = true;
      cSetting.getBanner(BANNER_TYPE_OBJ).then(res => {
        if (res && res.data) {
          this.data = res.data;
          this.imageList = res.data.map(item => `${this.baseUrl}/${item.image_url}`);
        }
        this.loading = false;
      });
    },
    edit(row) {
      this.defaultFormItem = { ...row };
      this.defaultData = {
        options: [
          {
            id: row.insider_posts_id,
            content_title: row.content_title
          }
        ],
        value: row.insider_posts_id
      };
      if (row.link_type === 2) {
        this.link_address = row.link_address;
      } else {
        this.post.insider_posts_id = row.insider_posts_id;
        this.post.content_title = row.content_title;
      }
      this.dialogVisible = true;
    },
    del(banner_ids) {
      this.$confirm('确认删除该轮播图？', '提示', {
        type: 'warning'
      })
        .then(() => {
          cSetting
            .delBanner({
              params: {
                banner_ids,
                ...BANNER_TYPE_OBJ
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.init();
              }
            });
        })
        .catch(() => {});
    },
    add() {
      this.link_address = '';
      this.defaultFormItem = {
        link_type: 1
      };
      this.defaultData = {};
      this.post.insider_posts_id = '';
      this.post.title = '';
      this.dialogVisible = true;
    },
    async submitForm() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        if (data.link_type === 1) {
          if (this.post.insider_posts_id) {
            data.insider_posts_id = this.post.insider_posts_id;
          } else {
            this.$message.warning('请检索帖子并选择！');
            return;
          }
        }
        if (data.link_type === 2) {
          if (this.link_address) {
            data.link_address = this.link_address;
          } else {
            this.$message.warning('请填写外链链接！');
            return;
          }
        }
        let res = null;
        if (this.defaultFormItem.id) {
          res = await cSetting.editBanner({
            params: { ...data, ...BANNER_TYPE_OBJ },
            banner_id: this.defaultFormItem.id
          });
        } else {
          res = await cSetting.addBanner({
            params: { ...data, ...BANNER_TYPE_OBJ }
          });
        }
        if (res) {
          this.$message.success(res.msg || '操作成功！');
          this.dialogVisible = false;
          this.init();
        }
      }
    },
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    },
    postshandleChange(value) {
      this.post.insider_posts_id = value;
    },
    gotoNewsContent(item) {
      localCache.setItem('newsContentDetail', { ...item, content_url: item.image_url });
      this.$router.push(`/${this.$route.params.user_id}/community/newsContentDetail/${item.id}`);
    }
  }
};
</script>
<style lang="less">
.c-setting {
  .input-group .el-input {
    width: 460px;
  }
  .el-image {
    vertical-align: middle;
    padding: 10px 0;
  }
  .sys-form {
    .item {
      display: flex;
      width: 400px;
      margin: 20px 0;
      > span {
        width: 80px;
        flex: none;
      }
    }
  }
}
</style>
